<template>
  <svg width="584" height="69" viewBox="0 0 584 69" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M267.31 65C266.586 65 266 65.6716 266 66.5C266 67.3284 266.586 68 267.31 68H532.69C533.414 68 534 67.3284 534 66.5C534 65.6716 533.414 65 532.69 65H267.31Z" fill="white"/>
    <path d="M147.31 54C146.586 54 146 54.6716 146 55.5C146 56.3284 146.586 57 147.31 57H412.69C413.414 57 414 56.3284 414 55.5C414 54.6716 413.414 54 412.69 54H147.31Z" fill="#CE123D"/>
    <g clip-path="url(#clip0_80_46776)">
      <path d="M543.294 67.002H581.767V21.9189C575.005 15.1347 567.835 7.94026 561.956 2.04175C555.108 2.07959 538.168 2.06182 531.287 2.06182V57.0042H540.216" stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/>
      <path d="M581.401 21.4364H560.701V2.97485" stroke="white" stroke-width="3" stroke-miterlimit="10"/>
      <path d="M549.323 45.3831L556.223 52.3061L563.123 45.3831" stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/>
      <path d="M556.15 51.5386V28.4617" stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/>
    </g>
    <path d="M573.118 62.0402C573.118 61.5513 572.718 61.1558 572.224 61.1558H0.893624C0.399687 61.1558 0 61.5513 0 62.0402C0 62.529 0.399687 62.9246 0.893624 62.9246H572.224C572.718 62.9246 573.118 62.529 573.118 62.0402Z" fill="#CE123D"/>
    <defs>
      <clipPath id="clip0_80_46776">
        <rect width="55" height="69" fill="white" transform="translate(529)"/>
      </clipPath>
    </defs>
  </svg>
</template>
